module.exports = __webpack_public_path__ + "img/scanner-gun.a93aa1cb.svg";